export const cloudinaryConfig = {
    cloudName: 'wellbeyond',
    photoUploadPreset: 'z2lxfc1h',
    videoUploadPreset: 'mc5aczwb'
};